module.exports = __webpack_public_path__ + "static/media/jake_k.8ff343a7.png";